import { BaseNodeModel } from "../BaseNodeModel";
import { PREDICATE } from "../ConstantNames";
export class QuaternaryNodeModel extends BaseNodeModel {
  constructor(options = {}) {
    super({
      type: 'quaternary',
      ...options
    });
  }

  removeElementFromMathView(name, type) {
    let removeElementFunction = type === PREDICATE ? this.getReduxProps()["removeQuaternaryPredicate"] : this.getReduxProps()["removeTernaryFunction"];
    removeElementFunction(name, this.getNodeNameCombination());
  }

  addElementToMathView(name, type) {
    let addElementFunction = type === PREDICATE ? this.getReduxProps()["addQuaternaryPredicate"] : this.getReduxProps()["addTernaryFunction"];
    addElementFunction(name, this.getNodeNameCombination());
  }

  removeNodeFromGraphView() {
    this.getReduxProps()["removeQuaternaryNode"](this.getNodeName());
  }

}